import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { hasCustomDynamicHeader } from "app/reducers/brandSelector";
import { getPartnerMarketing } from "app/reducers/partnerSelector";
import { useContext, useEffect, useState } from "react";
import { clearBooking } from "app/pages/Booking/bookingActionCreators";
import PropTypes from "prop-types";
import HomeLayout from "app/pages/HomeLayout/HomeLayout";
import { clearSmartDP, fetchSDPFilters } from "app/pages/SmartDP/smartDPActionCreators";
import {
	getActiveHeroCommercialMerchCode,
	getHeroCommercialCarouselMerchandisings,
} from "app/pages/Merchandising/merchandisingSelector";
import AppGlobalsContext from "app/AppGlobalsContext";
import { fetchMerchandisingApi } from "app/pages/Merchandising/merchandisingActionCreators";
import { fetchAllStopoverCities } from "app/pages/Stopover/stopoverActionCreators";
import { WEBSITE_TUNNEL_TYPES } from "app/constants";
import { fetchHotelOnlySearchFormAvailability } from "app/pages/HotelOnly/hotelOnlyActionCreator";

const HomeLayoutContainer = props => {
	const { shop, partnerCode, productsVisibility, brand } = useContext(AppGlobalsContext);
	const {
		heroCommercialCode,
		fetchAllStopoverCities,
		websiteTunnels,
		fetchSDPFilters,
		fetchHotelOnlySearchFormAvailability,
	} = props;
	const [heroCommercialMerch, setHeroCommercialMerch] = useState({});
	const locale = shop.slice(0, 2);
	const hasStopoverTunnel = websiteTunnels?.some(
		tunnel => tunnel?.websiteTunnelType === WEBSITE_TUNNEL_TYPES.STOPOVER
	);

	const hasHolidaysTunnel = websiteTunnels?.some(
		tunnel => tunnel?.websiteTunnelType === WEBSITE_TUNNEL_TYPES.HOLIDAYS
	);

	const hasHotelOnlyTunnel = websiteTunnels?.some(
		tunnel => tunnel?.websiteTunnelType === WEBSITE_TUNNEL_TYPES.HOTEL_ONLY
	);

	useEffect(() => {
		props.clearSmartDP();
		props.clearBooking();
	}, []);

	useEffect(() => {
		if (hasStopoverTunnel) {
			fetchAllStopoverCities({ brand, locale });
		}

		if (hasHolidaysTunnel || hasStopoverTunnel) {
			fetchSDPFilters();
		}

		if (hasHotelOnlyTunnel) {
			fetchHotelOnlySearchFormAvailability();
		}
	}, [brand, locale, hasStopoverTunnel, hasHolidaysTunnel, hasHotelOnlyTunnel]);

	useEffect(() => {
		if (heroCommercialCode) {
			fetchMerchandisingApi({
				code: heroCommercialCode,
				shop,
				productsVisibility,
				partnerCode,
			}).then(response => {
				setHeroCommercialMerch(response?.data?.merchandising);
			});
		}
	}, [heroCommercialCode, shop, productsVisibility, partnerCode]);

	return <HomeLayout {...props} heroCommercialMerch={heroCommercialMerch} />;
};

const mapStateToProps = state => {
	const marketing = getPartnerMarketing(state);
	return {
		isBrandWithCustomHeader: hasCustomDynamicHeader(state),
		isTransparentHeader: marketing?.isTransparentSdpSearchHeader || false,
		heroCommercialCode: getActiveHeroCommercialMerchCode(state),
		brandCode: state.brand?.code,
		carouselMerchandisings: getHeroCommercialCarouselMerchandisings(state),
		destinations: state.smartDP?.destinations,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			clearBooking,
			clearSmartDP,
			fetchSDPFilters,
			fetchHotelOnlySearchFormAvailability,
			fetchAllStopoverCities,
		},
		dispatch
	);
};

HomeLayoutContainer.propTypes = {
	clearBooking: PropTypes.func,
	clearSmartDP: PropTypes.func,
	fetchSDPFilters: PropTypes.func,
	fetchHotelOnlySearchFormAvailability: PropTypes.func,
	heroCommercialCode: PropTypes.string,
	fetchAllStopoverCities: PropTypes.func,
	websiteTunnels: PropTypes.array,
	carouselMerchandisings: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeLayoutContainer);
